import { useState } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { Box, Button } from "@mui/material";

import {
  DataGridPro,
  GridRowParams,
  useGridApiRef,
} from "@mui/x-data-grid-pro";
import themeInarix from "../StylesMuiInarix";
import UserLocationsColumns from "./UserLocationsFetchingColumns";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../redux/slices";
import AddIcon from "@mui/icons-material/Add";
import { ThunkDispatch } from "@reduxjs/toolkit";
import {
  setCreatedGroupValues,
  setFilterModel,
  setLocationColumns,
  setPreselectedFilterField,
  setSelectLocations,
  setShowFilterForm,
} from "../../redux/slices/fleet/locations";
import { useNavigate } from "react-router-dom";
import { selectLocale } from "../../redux/slices/layout";
import SearchComponent from "../customFilterComponent/searchComponent";
import customFilterStyles from "../customFilterComponent/customFiltersStyles";
import { DevicesStyles } from "../userDevices/DevicesStyles";
import { CustomFilterButton } from "../customFilterComponent/customFilterButton";
import { TFunction } from "i18next";
import logoInarixLayout from "../../assets/images/logo-inarix-lay.png";

const SetActions = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  return {
    setSelectLocations: (locations: any[]) => {
      dispatch(setSelectLocations(locations));
    },

    setCreatedGroupValues: (values: any) => {
      dispatch(setCreatedGroupValues(values));
    },

    setLocationColumnss: (columns: any[]) => {
      dispatch(setLocationColumns(columns));
    },

    /// custom filter component
    setFilterModel: (filterModel: any) => {
      dispatch(setFilterModel(filterModel));
    },

    setShowFilterForm: (show: boolean) => {
      dispatch(setShowFilterForm(show));
    },

    setPreselectedFilterField: (field: string | null) => {
      dispatch(setPreselectedFilterField(field));
    },
  };
};

export function UserLocationsTable(t: (arg0: string) => string) {
  const apiRef = useGridApiRef();
  const locale = useSelector(selectLocale);
  const {
    setCreatedGroupValues,
    setLocationColumnss,
    setFilterModel,
    setShowFilterForm,
    setPreselectedFilterField,
  } = SetActions();

  const {
    loading,
    createdGroups,
    selectedGroupTitle,
    filterModel,
    showFilterForm,
    preselectedFilterField,
  } = useSelector((state: State) => state.LocationsReducer);

  const [quickFilterValue, setQuickFilterValue] = useState("");

  const handleQuickFilterChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = event.target.value;
    setQuickFilterValue(value);

    if (apiRef.current) {
      apiRef.current.setQuickFilterValues(value ? [value] : []);
    }
  };

  const navigate = useNavigate();

  const locationsSelectedB =
    createdGroups.locationsSelectedAutoComplete.valuesSelected.map((d) => d.id);

  const { columns, locationsRows } = UserLocationsColumns(t);

  const topMenu = (
    <div className="container-options-locations-top-menu">
      <div className="top-menu-styles-locations">
        <div className="container-logo-title-locations">
          <img
            src={logoInarixLayout}
            data-cy="logo-inarix-layout"
            className="img-loc-log"
            alt="logoInarixLayout"
          />
          <div className="tab-title-locations">{selectedGroupTitle}</div>
        </div>
        <div>
          <Button
            disabled={loading}
            onClick={() => navigate("/site/create")}
            variant="contained"
            endIcon={<AddIcon />}
            sx={{ textTransform: "none" }}
          >
            {t("Locations.create_new_site")}
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="container-locations-table-">
      {topMenu}
      <Box sx={{ height: 500, width: 1, maxWidth: "calc(100% - 20px)" }}>
        <div style={customFilterStyles.filterContainer}>
          <SearchComponent
            t={t}
            quickFilterValue={quickFilterValue}
            handleQuickFilterChange={handleQuickFilterChange}
          />
          <div style={DevicesStyles.containerFilterButon}>
            <CustomFilterButton
              t={t as TFunction<"global", undefined>}
              isDisabled={false}
              loadingsValues={false}
              filterModel={filterModel}
              setShowFilterForm={setShowFilterForm}
              showFilterForm={showFilterForm}
              setPreselectedFilterField={setPreselectedFilterField}
              preselectedField={preselectedFilterField}
              columnsTable={columns as any}
              setFilterModel={setFilterModel}
              handleApplyFilters={() => {}}
              hasNoData={false}
            />
          </div>
        </div>
        <ThemeProvider theme={themeInarix(locale)}>
          <DataGridPro
            className="table-styles-alone"
            disableColumnSelector={true}
            disableRowSelectionOnClick={true}
            rows={locationsRows}
            columns={columns}
            rowHeight={78}
            loading={loading}
            pagination
            checkboxSelection
            rowSelectionModel={locationsSelectedB as number[]}
            pageSizeOptions={[25, 50, 100]}
            onColumnOrderChange={() => {
              setLocationColumnss(apiRef.current.getAllColumns());
            }}
            onColumnWidthChange={() =>
              setLocationColumnss(apiRef.current.getAllColumns())
            }
            isRowSelectable={(params: GridRowParams) => !params.row.shared}
            onRowSelectionModelChange={(e) => {
              const locationsOptions = e.map((location) => {
                const shared = apiRef.current.getCellValue(location, "shared");
                if (!shared) {
                  return {
                    id: location,
                    name: apiRef.current.getCellValue(location, "name"),
                  };
                } else {
                  return "";
                }
              });

              const transform = locationsOptions?.map((c: any) => c);

              setCreatedGroupValues({
                ...createdGroups,
                locationsSelectedAutoComplete: {
                  allValuesSelected: false,
                  valuesSelected: transform,
                },
              });
            }}
            initialState={{
              pagination: { paginationModel: { pageSize: 25 } },
            }}
            apiRef={apiRef}
            ignoreDiacritics={true}
          />
        </ThemeProvider>
      </Box>
    </div>
  );
}
